module.exports = __webpack_public_path__ + "img/19.4c412ce9.png";